import React from 'react'
import { Modal, Button, Input, Alert, ConfigProvider, message, Radio, RadioChangeEvent } from 'antd'
import { UserOutlined, LockOutlined, MobileOutlined, MailOutlined } from '@ant-design/icons'
import loginRegisterStyles from './login-register.module.less'
import './login-register.css'
import zhCN from 'antd/lib/locale/zh_CN'
import Cookies from 'js-cookie'
import localStorage from 'localStorage'
import { sendHttpPostRequest } from '../../../api/http-request'

let globalIsTeacher = false
/**
 * LoginRegisterModal
 * 登录注册模态框
 */
class LoginRegisterModal extends React.Component {
  // state 模态框显示状态
  state = {
    modalVisible: false, // 是否可见
    modalType: 1, // 1-注册  2-登录  3-找回密码

    idens: '', //帐号
    password: '', // 密码
    passwordConfirm: '', // 密码确认
    vcode: '', // 验证码（注册）
    retrievalVcode: '', // 验证码（密码找回）
    registerMode: false, // 注册模式
    errorMessage: '', // 错误码
    registerType: 'phone', //注册类型：phone 手机注册 email 邮箱注册
    sendVcodeTip: '发送验证码', // 验证码发送提示（注册）
    sendBtnDisabled: false, // 发送按钮不可用（注册）
    sendRetrievalVcodeTip: '发送验证码', // 验证码发送提示（密码找回）
    sendRetrievalBtnDisabled: false, // 发送按钮不可用（密码找回）
    inviter: '', // 邀请者
    is_local_deploy: false
  }

  constructor(props) {
    super(props)
    checkIsLocalDeploy(this)
  }

  // 绑定表单值
  handleChange(key, event) {
    this.setState({
      [key]: event.target.value,
    })
  }

  // 改变模态框类型
  handleModalTypeChange(key, value) {
    this.setState({ errorMessage: '' })
    this.setState({
      [key]: value,
    })
  }

  retrievalCallback(response) {
    message.destroy()
    if (response.is_ok) {
      message.success('密码重置成功，请使用新密码登录')
    } else {
      message.error('密码重置失败，请稍候再试')
    }
  }

  /**
   * 登录回调
   * @param response
   */
  loginCallback(response) {
    if (response.is_ok) {
      setCookie('sessionid', response.token)
      localStorage.setItem(
        'user_info',
        JSON.stringify(response.user_info.user_info)
      )
      globalIsTeacher = response.user_info.login_user_role == 2 ? true : false
      window.location.reload()
    } else {
      this.setState({ errorMessage: response.message })
    }
  }

  /**
   * 发送手机验证码或邮箱回调
   * @param response
   */
  sendPhoneVcodeCallback(response) {
    if (response.code == 0) {
      message.destroy()
      message.success(response.message)
      let times = 60
      this.setState({ sendVcodeTip: times + '秒后重发', sendBtnDisabled: true })
      let _this: any = this
      let time_handle = setInterval(function () {
        times -= 1
        if (times <= 0) {
          _this.setState({ sendVcodeTip: '发送验证码', sendBtnDisabled: false })
          clearInterval(time_handle)
        } else _this.setState({ sendVcodeTip: times + '秒后重发' })
      }, 1000)
    } else {
      this.setState({ errorMessage: response.message })
    }
  }

  /**
   * 发送短信验证码或邮箱验证码
   */
  checkPhone() {
    this.setState({ errorMessage: '' })
    const phone = this.state.idens

    if (this.state.registerType ==  "phone" ) {
      if (phone == '') {
        this.setState({ errorMessage: this.state.registerType ==  "phone"?'请输入手机号':'请输入邮箱' })
      }/* else if (!phone.match(is_mobile)) {
        this.setState({ errorMessage: '请输入正确的手机号' })
      }*/ else {
        try {
          sendHttpPostRequest(
            'account/api/send_sms/',
            { phone: phone, type: 1 },
            this.sendPhoneVcodeCallback.bind(this)
          )
        } catch (e) {
          console.error(e)
        }
      }
    }else {
      try {
        sendHttpPostRequest(
          'account/api/send_email',
          { email: phone, type: 1 },
          this.sendPhoneVcodeCallback.bind(this)
        )
      } catch (e) {
        console.error(e)
      }
    }
    
  }


  /**
   * 找回密码发送手机验证码回调
   * @param response
   */
  sendRetrievalPhoneVcodeCallback(response: any) {
    if (response.code == 0) {
      message.destroy()
      message.success(response.message)
      let times = 60
      this.setState({
        sendRetrievalVcodeTip: times + '秒后重发',
        sendRetrievalBtnDisabled: true,
      })
      let _this: any = this
      let time_handle = setInterval(function () {
        times -= 1
        if (times <= 0) {
          _this.setState({
            sendRetrievalVcodeTip: '发送验证码',
            sendRetrievalBtnDisabled: false,
          })
          clearInterval(time_handle)
        } else _this.setState({ sendRetrievalVcodeTip: times + '秒后重发' })
      }, 1000)
    } else {
      this.setState({ errorMessage: response.message })
    }
  }

  /**
   * 找回密码 发送短信验证码或邮箱验证码
   */
  retrievalCheckPhone() {
    this.setState({ errorMessage: '' })
    const phone = this.state.idens

    if (phone.indexOf("@") == -1) {
      if (phone == '') {
        this.setState({ errorMessage: '请输入手机号或邮箱' })
      }else {
        try {
          sendHttpPostRequest(
            'account/api/send_sms/',
            { phone: phone, type: 2 },
            this.sendRetrievalPhoneVcodeCallback.bind(this)
          )
        } catch (e) {
          console.error(e)
        }
      }
    }else {
      if (phone == '') {
        this.setState({ errorMessage: '请输入手机号或邮箱' })
      }else {
        try {
          sendHttpPostRequest(
            'account/api/send_email',
            { email: phone, type: 2 },
            this.sendRetrievalPhoneVcodeCallback.bind(this)
          )
        } catch (e) {
          console.error(e)
        }
      }
    }

  }

  handleGoLogin() {
    doLogin(this)
  }

  handleGoRegister() {
    doRegister(this)
  }

  handleGoRetrieval() {
    doRetrieval(this)
  }

  // 渲染
  render() {
    return (
      <>
        <ConfigProvider locale={zhCN}>
          <Button
            style={{ color: '#4f46e5' }}
            className={loginRegisterStyles.buttons}
            hidden={true}
            id="show-register-modal"
            type="primary"
            onClick={() => this.setState({ modalVisible: true, modalType: 1 })}
          >
            注册
          </Button>
          <Button
            style={{ color: '#4f46e5' }}
            className={loginRegisterStyles.buttons}
            hidden={true}
            id="show-login-modal"
            type="primary"
            onClick={() => this.setState({ modalVisible: true, modalType: 2 })}
          >
            登录
          </Button>
          <Modal
            className="login-register-modal"
            centered
            closable={true}
            width={420}
            open={this.state.modalVisible}
            footer={null}
            onCancel={() => this.setState({ modalVisible: false })}
          >
            <div
              className={loginRegisterStyles.pageRegister}
              hidden={this.state.modalType != 1}
            >
              <div className={loginRegisterStyles.modalShell}>
                <div className={loginRegisterStyles.modalHeader}>
                  <div className={loginRegisterStyles.modalTitle}>创建账号</div>
                  <div className={loginRegisterStyles.modalDesc}>注册后即可开始学习编程</div>
                </div>

                <Alert className={loginRegisterStyles.authAlert} message="如收不到手机验证码请切换为邮箱注册" type="warning" showIcon={true} />

                <div className={loginRegisterStyles.registerTypeWrapper}>
                  <Radio.Group defaultValue="phone"  onChange = {(e: RadioChangeEvent) => {
                       this.setState({ registerType: e.target.value, errorMessage: '' }) } }>
                    <Radio.Button value="phone">手机号注册</Radio.Button>
                    <Radio.Button value="email">邮箱注册</Radio.Button>
                  </Radio.Group>
                </div>

                <div className={loginRegisterStyles.errorMsg} id="error-message-register">
                  {this.state.errorMessage}
                </div>

                {this.state.registerType ==  "phone" ?  (<Input
                  id="register-phone"
                  name="register-phone"
                  className={loginRegisterStyles.inputField}
                  value={this.state.idens}
                  placeholder="请输入手机号"
                  required={true}
                  prefix={<UserOutlined />}
                  onChange={this.handleChange.bind(this, 'idens')}
                />) :  (<Input
                  id="register-email"
                  name="register-email"
                  className={loginRegisterStyles.inputField}
                  value={this.state.idens}
                  placeholder="请输入邮箱"
                  required={true}
                  prefix={<MailOutlined />}
                  onChange={this.handleChange.bind(this, 'idens')}
                />)}

                {this.state?.is_local_deploy !== true && (
                <div className={loginRegisterStyles.codeRow}>
                  <div className={loginRegisterStyles.codeInput}>
                  {this.state.registerType ==  "phone" ? (
                  <Input
                    id="register-phone-vcode"
                    name="register-phone-vcode"
                    className={loginRegisterStyles.inputField}
                    style={{marginBottom: 0}}
                    placeholder="短信验证码"
                    maxLength={6}
                    onChange={this.handleChange.bind(this, 'vcode')}
                    prefix={<MobileOutlined />}
                  />
                  ) : (
                  <Input
                    id="register-email-vcode"
                    name="register-email-vcode"
                    className={loginRegisterStyles.inputField}
                    style={{marginBottom: 0}}
                    placeholder="邮箱验证码"
                    maxLength={6}
                    onChange={this.handleChange.bind(this, 'vcode')}
                    prefix={<MobileOutlined />}
                  />
                  )}
                  </div>
                  <Input
                    onClick={this.checkPhone.bind(this)}
                    type="button"
                    className={loginRegisterStyles.sendVcode}
                    value={this.state.sendVcodeTip}
                    disabled={this.state.sendBtnDisabled}
                  />
                </div>
                )}

                <Input
                  id="register-password"
                  name="register-password"
                  className={loginRegisterStyles.inputField}
                  placeholder="请输入密码，6-20位"
                  maxLength={20}
                  prefix={<LockOutlined />}
                  type={'password'}
                  onChange={this.handleChange.bind(this, 'password')}
                />
                <Input
                  id="register-password-confirm"
                  name="register-password-confirm"
                  className={loginRegisterStyles.inputField}
                  placeholder="请再输入一遍密码"
                  prefix={<LockOutlined />}
                  onChange={this.handleChange.bind(this, 'passwordConfirm')}
                  type="password"
                />
                <Input
                  id="register-inviter"
                  name="register-inviter"
                  className={loginRegisterStyles.inputField}
                  placeholder="请输入邀请人手机号(可选)"
                  onChange={this.handleChange.bind(this, 'inviter')}
                  prefix={<UserOutlined />}
                />
                <div
                  onClick={this.handleGoRegister.bind(this)}
                  className={loginRegisterStyles.btnRegister}
                >
                  注 &nbsp;&nbsp;册
                </div>
                <div className={loginRegisterStyles.footerLinks}>
                  <span className={loginRegisterStyles.helperText}>已有帐号？</span>
                  <span
                    className={loginRegisterStyles.linkText}
                    onClick={this.handleModalTypeChange.bind(
                      this,
                      'modalType',
                      2
                    )}
                  >
                    返回登录
                  </span>
                </div>
              </div>
            </div>
            <div
              className={loginRegisterStyles.pageLogin}
              hidden={this.state.modalType != 2}
            >
              <div className={loginRegisterStyles.modalShell}>
                <div className={loginRegisterStyles.modalHeader}>
                  <div className={loginRegisterStyles.modalTitle}>欢迎登录</div>
                  <div className={loginRegisterStyles.modalDesc}>登录后继续您的学习之旅</div>
                </div>

                <div className={loginRegisterStyles.errorMsg} id="error-message-login">
                  {this.state.errorMessage}
                </div>
                <Input
                  id="login-input-phone"
                  className={loginRegisterStyles.inputField}
                  placeholder="请输入手机号或邮箱"
                  required={true}
                  prefix={<UserOutlined />}
                  onChange={this.handleChange.bind(this, 'idens')}
                  value={this.state.idens}
                />
                <Input.Password
                  type="password"
                  className={loginRegisterStyles.inputField}
                  id="login-input-password"
                  placeholder="请输入密码，6-20位"
                  maxLength={20}
                  onChange={this.handleChange.bind(this, 'password')}
                  prefix={<LockOutlined />}
                />
                <div
                  onClick={this.handleGoLogin.bind(this)}
                  className={loginRegisterStyles.btnRegister}
                  id={'login-button'}
                >
                  登 &nbsp;&nbsp;录
                </div>
                <div className={loginRegisterStyles.footerLinks}>
                  <span className={loginRegisterStyles.helperText}>还没有帐号？</span>
                  <span
                    className={loginRegisterStyles.linkText}
                    onClick={this.handleModalTypeChange.bind(
                      this,
                      'modalType',
                      1
                    )}
                  >
                    去注册
                  </span>
                </div>
                <div className={loginRegisterStyles.footerLinks} style={{marginTop: 4}}>
                  <span
                    className={loginRegisterStyles.linkText}
                    style={{fontWeight: 400}}
                    onClick={this.handleModalTypeChange.bind(
                      this,
                      'modalType',
                      3
                    )}
                  >
                    忘记密码？
                  </span>
                </div>
              </div>
            </div>
            <div
              className={loginRegisterStyles.modalRetrieval}
              hidden={this.state.modalType != 3}
            >
              <div className={loginRegisterStyles.modalShell}>
                <div className={loginRegisterStyles.modalHeader}>
                  <div className={loginRegisterStyles.modalTitle}>找回密码</div>
                  <div className={loginRegisterStyles.modalDesc}>通过手机号或邮箱重置密码</div>
                </div>

                <div className={loginRegisterStyles.errorMsg} id="error-message-retrieval">
                  {this.state.errorMessage}
                </div>
                <Input
                  className={loginRegisterStyles.inputField}
                  placeholder="请输入手机号或邮箱"
                  required={true}
                  value={this.state.idens}
                  onChange={this.handleChange.bind(this, 'idens')}
                  prefix={<UserOutlined />}
                />

                {this.state?.is_local_deploy !== true && (
                <div className={loginRegisterStyles.codeRow}>
                  <div className={loginRegisterStyles.codeInput}>
                    <Input
                      className={loginRegisterStyles.inputField}
                      style={{marginBottom: 0}}
                      placeholder="请输入验证码"
                      maxLength={6}
                      onChange={this.handleChange.bind(this, 'retrievalVcode')}
                      prefix={<MobileOutlined />}
                    />
                  </div>
                  <Input
                    onClick={this.retrievalCheckPhone.bind(this)}
                    type="button"
                    className={loginRegisterStyles.sendVcode}
                    value={this.state.sendRetrievalVcodeTip}
                    disabled={this.state.sendRetrievalBtnDisabled}
                  />
                </div>
                )}

                <Input
                  className={loginRegisterStyles.inputField}
                  placeholder="请输入新密码，6-20位"
                  maxLength={20}
                  prefix={<LockOutlined />}
                  onChange={this.handleChange.bind(this, 'password')}
                  type={'password'}
                />
                <Input
                  className={loginRegisterStyles.inputField}
                  placeholder="请再输入一遍新密码"
                  prefix={<LockOutlined />}
                  onChange={this.handleChange.bind(this, 'passwordConfirm')}
                  type={'password'}
                />
                <div
                  onClick={this.handleGoRetrieval.bind(this)}
                  className={loginRegisterStyles.btnRegister}
                >
                  重 &nbsp;&nbsp;置
                </div>
                <div className={loginRegisterStyles.footerLinks}>
                  <span
                    className={loginRegisterStyles.linkText}
                    style={{fontWeight: 400}}
                    onClick={this.handleModalTypeChange.bind(
                      this,
                      'modalType',
                      2
                    )}
                  >
                    返回登录
                  </span>
                </div>
              </div>
            </div>
          </Modal>
        </ConfigProvider>
      </>
    )
  }
}

export default LoginRegisterModal

/**
 * 调后端登录接口
 */
export function doLogin(_this: any) {
  const phone = _this.state.idens
  const password = _this.state.password
  if (!phone) {
    _this.setState({ errorMessage: '请输入手机号或邮箱' })
    return false
  }else if (!password) {
    _this.setState({ errorMessage: '请输入密码' })
    return false
  } else if (password.length < 6 || password.length > 20) {
    _this.setState({ errorMessage: '密码长度应为6-20位' })
    return false
  }

  _this.setState({ errorMessage: '' })
  try {
    sendHttpPostRequest(
      'account/api/login/',
      { idens: phone, password: password },
      _this.loginCallback.bind(_this)
    )
  } catch (e) {
    console.error(e)
  }
}

/**
 * 手机号或邮箱注册
 * @param _this
 */
export function doRegister(_this: any) {
  const user_name = _this.state.idens
  const phone = _this.state.idens
  const password = _this.state.password
  const phone_vcode = _this.state.vcode
  const password_confirm = _this.state.passwordConfirm
  const inviter = _this.state.inviter
  const is_mobile = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/
  if (!phone) {
    _this.setState({ errorMessage: '请输入手机号或邮箱' })
    return false
  }else if (!phone_vcode && _this.state?.is_local_deploy == false) {
    _this.setState({ errorMessage: '请输入验证码' })
    return false
  } else if (!user_name) {
    _this.setState({ errorMessage: '请输入姓名' })
    return false
  } else if (!password) {
    _this.setState({ errorMessage: '请输入密码' })
    return false
  } else if (password.length < 6 || password.length > 20) {
    _this.setState({ errorMessage: '密码长度应为6-20位' })
    return false
  } else if (!password_confirm) {
    _this.setState({ errorMessage: '请输入密码确认' })
    return false
  } else if (password != password_confirm) {
    _this.setState({ errorMessage: '两次输入的密码不一致' })
    return false
  }
  if (inviter) {
    if (!inviter.match(is_mobile)) {
      _this.setState({ errorMessage: '请输入正确的邀请人手机号' })
      return false
    } else if (inviter.trim() == phone.trim()) {
      _this.setState({ errorMessage: '亲，您不能邀请自己~' })
      return false
    }
  }
  _this.setState({ errorMessage: ' ' })

  let data = {
    user_name: user_name,
    idens: phone,
    password: password,
    phone_vcode:
      _this.state?.is_local_deploy == true ? '123456' : phone_vcode,
    password_confirm: password_confirm,

    inviter: inviter,
    channel: 3,
  }


  if (_this.state?.is_local_deploy == true) {
    Object.assign(data, { mode: 2 })
  }

  if (_this.state.registerType ==  "phone" ) {
    try {
      sendHttpPostRequest(
        'account/api/register',
        data,
        _this.loginCallback.bind(_this)
      )
    } catch (e) {
      console.error(e)
    }
  }else {
    Object.assign(data, { email_vcode: phone_vcode })
    try {
      sendHttpPostRequest(
        'account/api/register_by_email',
        data,
        _this.loginCallback.bind(_this)
      )
    } catch (e) {
      console.error(e)
    }
  }



}

/**
 * 找回密码
 * @param _this
 */
function doRetrieval(_this: any) {
  const phone = _this.state.idens
  const password = _this.state.password
  const password_confirm = _this.state.passwordConfirm
  const phone_vcode = _this.state.retrievalVcode

  if (!phone) {
    _this.setState({ errorMessage: '请输入手机号' })
    return false
  }/* else if (!phone.match(is_mobile)) {
    _this.setState({ errorMessage: '请输入正确的手机号' })
    return false
  }*/ else if (!phone_vcode && _this.state?.is_local_deploy == false) {
    _this.setState({ errorMessage: '请输入手机验证码' })
    return false
  } else if (!password) {
    _this.setState({ errorMessage: '请输入新密码' })
    return false
  } else if (password.length < 6 || password.length > 20) {
    _this.setState({ errorMessage: '密码长度应为6-20位' })
    return false
  } else if (!password_confirm) {
    _this.setState({ errorMessage: '请输入新密码确认' })
    return false
  } else if (password != password_confirm) {
    _this.setState({ errorMessage: '两次输入的密码不一致' })
    return false
  }

  _this.setState({ errorMessage: ' ' })

  let data = {
    idens: phone,
    password: password,
    //phone_vcode:
      //_this.state?.is_local_deploy == true ? '123456' : phone_vcode,
    password_confirm: password_confirm,
  }

  if (_this.state?.is_local_deploy == true) {
    Object.assign(data, { mode: 2 })
  }

  if(phone.indexOf('@') !== -1) {
    Object.assign(data, { email_vcode:  phone_vcode})
  }else {
    let phone_vcode_final = _this.state?.is_local_deploy == true ? '123456' : phone_vcode
    Object.assign(data, { phone_vcode:  phone_vcode_final})
  }
  try {
    sendHttpPostRequest(
      'account/api/password_retrieval/',
      data,
      _this.retrievalCallback.bind(_this)
    )
  } catch (e) {
    console.error(e)
  }
}

/**
 * 设置cookie
 * @param key
 * @param value
 */
export function setCookie(key: any, value: any) {
  const date: any = new Date()
  date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + date.toGMTString()
  document.cookie = key + '=' + value + '; ' + expires
}

/**
 * 删除cookie
 * @param key
 */
export function delCookie(key: any) {
  const date: any = new Date()
  date.setTime(date.getTime() - 10000)
  const expires = '=; expires=; ' + date.toGMTString()
  document.cookie = key + expires
}

/**
 * 获取cookie
 * @param key
 */
export function getCookie(key: any) {
  let arr,
    reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)')
  if ((arr = document.cookie.match(reg))) return unescape(arr[2])
  else return null
}

/**
 * 外部调用判断是否是老师
 */
export function checkIsTeacher() {
  let localUserInfo = JSON.parse(localStorage.getItem('user_info'))
  if (localUserInfo) {
    let userRole = localUserInfo.login_user_role
    globalIsTeacher = userRole == 2 ? true : false
  } else {
    sendHttpPostRequest(
      'account/api/query_teacher_authenticate/',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          // document.getElementById("show-login-modal")!.click();
        } else if (response.code == 0) {
          // 成功且申请过
          if (response.deal_method == 3) {
            // 处理通过，已经是教师身份
            if (response.teacher_info.role == 2) {
              globalIsTeacher = true
            }
          } else if (response.deal_method == 4) {
            // 被驳回
          }
          if (response.teacher_info.role == 4) {
            // 管理员
            globalIsTeacher = true
          }
        } else if (response.code == -2) {
          // 未申请过
        } else {
          message.error(response.message)
        }
      }
    )
  }
  return globalIsTeacher
}


/**
 * 查询后端，返回是否是本地部署
 */
function checkIsLocalDeploy(_this: any) {

  let data = {

  }
  try {
    sendHttpPostRequest(
      'get_is_deploy',
      data,
      (response)=> {
        message.destroy()
        if (response.is_ok) {
          if(response?.deploy_type == 2){
             _this.setState({ is_local_deploy: true })
          }
        } else {
          //message.error('密码重置失败，请稍候再试')
        }
      }
    )
  } catch (e) {
    console.error(e)
  }
}